<template>
  <div class="layout">
    <Layout>
      <Header>
        <Menu mode="horizontal" theme="primary" :active-name="activeMenu" @on-select="menuClick">
          <li class="logo">
            HOMEWORK
          </li>

          <Menu-Item v-for="(m ,key) in menuAuth" :key="key" :name="key" v-show="m.show">
            <Icon :type="m.icon"></Icon>{{m.desc}}
          </Menu-Item>

          <li class="login-user">
            <Avatar icon="person" :style="{ 'background-color': accountsError ? '#bbbec4' : '#87d068' }"/>

            <a class="account-num" v-if="!accountsError && !!user">
              [{{uTypeMap[user.utype]}}] {{user.name}}
            </a>

            <span v-if="accountsError">
              <span>{{accountsError}}</span>
            </span>
          </li>
        </Menu>
      </Header>
      <Content :style="{padding: '0 50px'}">
        <Breadcrumb :style="{margin: '20px 0'}">
          <BreadcrumbItem v-if="accounts && accounts.length>0">
            <img src="../../static/logo.png" style="width: 20px;height: 20px; position: absolute"/>
            <span style="margin-left: 20px;">【 {{accounts[0]}} 】</span>
            <span v-if="!accountsError && !!user">
              [{{uTypeMap[user.utype]}}] {{user.name}}
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem>家庭作业</BreadcrumbItem>
          <BreadcrumbItem v-if="!!menuAuth[activeMenu]">{{menuAuth[activeMenu].desc}}</BreadcrumbItem>
        </Breadcrumb>
        <Card>
          <div class="content">
            <router-view/>
          </div>
        </Card>
      </Content>
      <Footer class="layout-footer-center">
        使用 <a href="https://nebulas.io" target="_blank">星云链</a> 驱动&nbsp;
        |&nbsp;<a href="mailto:86369340@qq.com">联系作者</a>&nbsp;
        |&nbsp;<a href="https://incentive.nebulas.io/cn/signup.html?invite=iyhSi" target="_blank">提交DAPP获得100NAS币</a></Footer>
    </Layout>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      uTypeMap: {'TEACHER': '老师', 'STUDENT': '学生'},
      menuAuth: {
        help: {show: true, desc: '使用帮助', icon: 'ios-paper'},
        homeworkList: {show: true, desc: '作业展示', icon: 'ios-paper'},
        signUp: {show: false, desc: '用户注册', icon: 'ios-paper'},
        homeworkPublish: {show: false, desc: '作业发布', icon: 'ios-paper'},
        homeworkMine: {show: false, desc: '我的作业', icon: 'ios-paper'}
      }
    }
  },
  methods: {
    menuClick: function (key) {
      this.$router.push('/' + key)
    },
    goHelp: function () {
      this.$router.push('/help')
    },
    // 加载钱包账户
    loadBaseAcc: function () {
      var vueThis = this
      vueThis.$store.dispatch('initBaseAccount').then(() => {
        // 菜单权限展示控制
        vueThis.isValidRouteAuth()
      }, function (error) {
        vueThis.showErr(error);
        vueThis.isValidRouteAuth()
      })
    },
    // 菜单权限展示控制
    isValidRouteAuth: function (to) {
      let vueThis = this
      vueThis.$Spin.show();
      // 这里根据业务场景可以限制vueThis.menuAuth中具体菜单的show属性值
      let menuKey = to ? to.name : vueThis.$route.name
      let isHaveAcc = vueThis.accounts && vueThis.accounts.length > 0;
      let isTeacher = vueThis.user && vueThis.user.utype === 'TEACHER';
      let isStudent = vueThis.user && vueThis.user.utype === 'STUDENT';

      vueThis.menuAuth.signUp.show = isHaveAcc && !isTeacher && !isStudent;
      vueThis.menuAuth.homeworkPublish.show = isTeacher;
      vueThis.menuAuth.homeworkMine.show = isTeacher || isStudent;

      // 权限
      if (!vueThis.menuAuth[menuKey].show) {
        vueThis.$router.push('/help')
      }
      vueThis.$Spin.hide();
    }
  },
  created () {
    this.loadBaseAcc()
  },
  computed: mapState([
    'activeMenu',
    'accounts',
    'accountsError',
    'user'
  ]),
  watch: {
    user (curVal, oldVal) {
      if (!_.isEqual(curVal, oldVal)) {
        console.log('检测用户发生变化，重新登录')
        this.isValidRouteAuth()
      }
    },
    $route (to) {
      this.isValidRouteAuth(to)
    }
  }
}
</script>

<style scoped>
.logo{
  width: 150px;
  float: left;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  color:white;
  font-family: "Microsoft YaHei" "Songti SC";
}
.ivu-layout-header{
  background: #2d8cf0;
}
.layout{
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-logo{
  width: 100px;
  height: 30px;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 15px;
  left: 20px;
}
.layout-nav{
  width: 420px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center{
  text-align: center;
}
.content{
  padding: 20px;
  font-size: 14px;
  width: 100%;
  min-height: 450px;
}

.login-user {
  float: right;
  color: white;
}
.login-user .account-num{
  color: white;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/app.vue